module.exports = __webpack_public_path__ + "602859bd469800c6205701f5a16b1a1b.woff";